import SkyNetObjectProfile from 'app/shared-components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from 'app/shared-components/SkyBaseDataGrid'
import domainConfig from './ContractBasisDemo.config'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const ContractBasisDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
            featuresLists={featuresLists}
        />
    )
}

export default ContractBasisDemoPage
